export default (state, action) => {
  switch (action.type) {
    // change Adults count
    case 'increaseAdults':
      if (state.adults < 6) {
        return {
          ...state,
          adults: state.adults + 1,
        };
      }
      return state;

    case 'decreaseAdults':
      if (state.adults > 1) {
        return {
          ...state,
          adults: state.adults - 1,
        };
      }
      return state;

    case 'setAdults':
      return {
        ...state,
        adults: action.payload,
      };

    // change Kids count
    case 'setKids':
      return {
        ...state,
        kids: action.payload,
      };

    case 'setNightsFrom':
      return {
        ...state,
        nightsFrom: action.payload,
      };

    case 'setNightsTo':
      return {
        ...state,
        nightsTo: action.payload,
      };

    case 'selectionNightsFrom':
      return {
        ...state,
        selectionNightsFrom: action.payload,
      };

    case 'selectionNightsTo':
      return {
        ...state,
        selectionNightsTo: action.payload,
      };

    case 'changeDepatureCity':
      return {
        ...state,
        depatureCity: action.payload,
      };

    case 'changeSelectedResorts':
      return {
        ...state,
        selectedResorts: action.payload,
      };

    case 'changeResortOptions':
      return {
        ...state,
        resortOptions: action.payload,
      };

    case 'changeDestination':
      return {
        ...state,
        destination: action.payload,
      };

    case 'changeSearchInputValue':
      return {
        ...state,
        searchInputValue: action.payload,
      };

    case 'changeDepartureDate':
      return {
        ...state,
        departureDate: action.payload,
      };

    case 'changeCalendarSelected':
      return {
        ...state,
        calendarSelected: action.payload,
      };

    case 'changeAvailableDays':
      return {
        ...state,
        availableDays: action.payload,
      };

    case 'changeAvailableDaysKey':
      return {
        ...state,
        availableDaysKey: action.payload,
      };

    case 'changeSearchResult':
      return {
        ...state,
        searchResult: action.payload,
      };

    case 'changeLoginModalVisibility':
      return {
        ...state,
        isLoginModalVisible: action.payload,
      };

    case 'changeUserAuthStatus':
      return {
        ...state,
        isUserLoggedIn: action.payload,
      };

    case 'changeTimeIsUpVisibility':
      return {
        ...state,
        timeIsUpModalVisible: action.payload,
      };

    case 'changeHotelDetailsFilterMenuVisibility':
      return {
        ...state,
        hotelDetailsFilterMenuVisibility: action.payload,
      };

    case 'changeOnlyCharter':
      return {
        ...state,
        onlyCharter: action.payload,
      };

    case 'changeDirectFlight':
      return {
        ...state,
        directFlight: action.payload,
      };

    case 'changeDestinationButton':
      return {
        ...state,
        destinationButton: action.payload,
      };

    case 'changeNightsButton':
      return {
        ...state,
        nightsButton: action.payload,
      };

    // filters
    case 'changeHotelsFilter':
      return {
        ...state,
        hotelsFilter: action.payload,
      };

    case 'changeStarsFilter':
      return {
        ...state,
        starsFilter: action.payload,
      };

    case 'changeStarsFilterHover':
      return {
        ...state,
        starsFilterHover: action.payload,
      };

    case 'changeMealsFilter':
      return {
        ...state,
        mealsFilter: action.payload,
      };

    case 'changeRatingFilter':
      return {
        ...state,
        ratingFilter: action.payload,
      };

    case 'changeBeachLineFilter':
      return {
        ...state,
        beachLineFilter: action.payload,
      };

    case 'changeBeachTypesFilter':
      return {
        ...state,
        beachTypesFilter: action.payload,
      };

    case 'changeHotelTypeFilter':
      return {
        ...state,
        hotelTypeFilter: action.payload,
      };

    case 'changeHotelServicesFilter':
      return {
        ...state,
        hotelServicesFilter: action.payload,
      };

    case 'changeCurrency':
      return {
        ...state,
        currency: action.payload,
      };

    case 'changeRegionsOptions':
      return {
        ...state,
        regionsOptions: action.payload,
      };

    case 'changeIsAllRegionsFilterTab':
      return {
        ...state,
        isAllRegionsFilterTab: action.payload,
      };

    case 'changeOperatorsFilter':
      return {
        ...state,
        operatorsFilter: action.payload,
      };

    case 'changeIsAllOperatorsTab':
      return {
        ...state,
        isAllOperatorsTab: action.payload,
      };

    case 'changeSelectedHotels':
      return {
        ...state,
        selectedHotels: action.payload,
      };

    case 'changeContactModalVisible':
      return {
        ...state,
        contactModalVisible: action.payload,
      };

    case 'changeHelpModalVisibility':
      return {
        ...state,
        helpModalVisible: action.payload,
      };

    case 'changeUserFirstLetter':
      return {
        ...state,
        userFirstLetter: action.payload,
      };

    case 'changeCoockieModalVisible':
      return {
        ...state,
        isCoockieModalVisible: action.payload,
      };

    case 'changeOtherToursCoords':
      return {
        ...state,
        otherToursCoords: action.payload,
      };

    case 'changeTouristsSearchText':
      return {
        ...state,
        touristsSearchText: action.payload,
      };

    case 'changeDatesSearchText':
      return {
        ...state,
        datesSearchText: action.payload,
      };

    case 'changeTouristsPopupVisible':
      return {
        ...state,
        touristsPopupVisible: action.payload,
      };

    default:
      return state;
  }
};
